import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import Cookies from "js-cookie";

import { GET_USER_NAME, GET_USER_LEVEL, GET_TOKEN, EXPECTED_COOKIES } from './../../helpers';
import { USER_MENU_ITEMS, API_URL, POST_ADMIN_CURRENT_COMPANY, GET_NOTIFICATIONS, POST_NOTIFICATIONS_SEEN, GET_NOTIFICATIONS_MENU, POST_NOTIFICATIONS_ALL_READ} from './../../constants';

import { ContextNotifications } from './../../Context/ContextNotifications';

import { Notifications } from './Notifications/Notifications';
import { SelectInput } from '../Global/SelectInput/SelectInput';
import mainLogo from './../../images/main_logo.svg';

import "./header.css";

const Header = (props) => {
  const history = useHistory();

  const [showMenu, setShowMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [currentProject, setCurrentProject] = useState('')
  const [adminOptions, setAdminOptions] = useState([]);

  // Notifications
  const [notifications, setNotifications] = useState([]);
  const [notificationsInfo, setNotificationsInfo] = useState({});
  const [seenNotif, setSeenNotif] = useState([])

  const userMenu = useRef(null);
  const notifMenuRef = useRef(null);
  const newNotifications = notifications.length - seenNotif.length

  const handleClickOutside = (e) => {
    if (userMenu && userMenu.current && !userMenu.current.contains(e.target)) {
      setShowMenu(false);
    }

    if (notifMenuRef && notifMenuRef.current && !notifMenuRef.current.contains(e.target)) {
      setShowNotifications(false)
    }
  };

  const handleLogout = () => {
    if (props.userLoggedIn) {
      // eslint-disable-next-line
      return props.initiateLogOut(), setShowMenu(false), history.push("/login");
    }
  };

  const handleSelectAnotherProject = (selectedProject) => {
    setCurrentProject(selectedProject)

    const body = JSON.stringify({
      id: selectedProject.value
    })

    fetch(API_URL + POST_ADMIN_CURRENT_COMPANY, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: body
    }).then((response) => response.json())
      .then((response) => {
        Cookies.set(EXPECTED_COOKIES.userJwt.name, response.access_token)
      })
      .then(() => window.location.reload())
      .catch(error => console.log(error))
  }

  const submitSeenNotifications = (notificationID, type = '') => {
    fetch(API_URL + POST_NOTIFICATIONS_SEEN + notificationID + '/seen', {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      })
    })
      .then((response) => response.json())
      .then(res => {
        if (type == 'change') handleSelectAnotherProject({label: res.company.name, value: res.company.id}, '/dashboard/adminfileimport')
        console.log(res)
      })
      .then(res => console.log(res))
      .catch(err => console.log(err))
  }

  const fetchNotifications = () => {
    fetch(API_URL + GET_NOTIFICATIONS, {
      method: "GET",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => setNotifications([...response]))
  }

  const fetchNotificationsUnread = () => {
    fetch(API_URL + GET_NOTIFICATIONS_MENU, {
      method: "GET",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      // .then((response) => console.log(response))
      .then((response) => setNotificationsInfo(response))
  }

  const markAllAsRead = () => {
    fetch(API_URL + POST_NOTIFICATIONS_ALL_READ, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      })
    })
    .then(() => setShowNotifications(false))
    .catch(error => console.log(error));
  }

  useEffect(() => {
    showMenu && 
      document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
  }, [showMenu]);

  useEffect(() => {
    showNotifications && 
      document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
  }, [showNotifications]);

  useEffect(() => {
    (props.userData.company !== undefined && props.userData.company?.name) && 
      setCurrentProject(props.userData?.company?.name)
  }, [props.userData])

  useEffect(() => {
    let projectArray = [];

    if (props.userData.companies !== undefined && GET_USER_LEVEL() >= 3) {
      props.userData.companies.map((item, i) => {
        return projectArray = [
          ...projectArray,
          {
            label: item.name ? item.name : `Company id:${item.id}`,
            value: item.id,
          }
        ]
      })

      return setAdminOptions(projectArray)
    }
  }, [props.userData.companies])

  useEffect(() => {
    let newArray = notifications;

    setSeenNotif(newArray.filter((item) => item.status === 'seen'))
  }, [notifications])

  // Get Notifications
  useEffect(() => {
    if(GET_TOKEN()) {
      fetchNotificationsUnread()
      fetchNotifications()

      let fetchNotificationsUnreadInfo = setInterval(() => fetchNotificationsUnread(), 10000);
      let fetchNotificationsInfo = setInterval(() => fetchNotifications(), 10000);

      return () => {
        clearInterval(fetchNotificationsUnreadInfo)
        clearInterval(fetchNotificationsInfo)
      }
    }
  }, [showNotifications, props.userLoggedIn])

  useEffect(() => {
    adminOptions.filter((item) => {item.value === props.userData.company.id && setCurrentProject(item)})
  }, [adminOptions])

  return (
    <div className="Header">
      <div className="max-width-wrapper">
        <div className="Header__content flex-space-between">

          <div className="logo-wrapper flex">
            <Link to={"/dashboard/dashboard"} exact="true" className="main-logo">
              <img src={mainLogo} alt='1STOPVAT Logo' />
            </Link>
            {
              ((GET_USER_LEVEL() >= 3) && (adminOptions.length > 0)) && (
                <SelectInput
                  inputName="admin_company_select"
                  inputValueHandler={(value => {
                    // Not allowing same selection
                    return value.value !== currentProject.value 
                      ? handleSelectAnotherProject(value)
                      : false
                  })}
                  value={currentProject}
                  selectValues={adminOptions}
                  noOptionsMessage='No Other Projects'

                />
              )
            }
          </div>


          {props.userLoggedIn && (
            <div className="user-content flex-align-center">

              <div className="Header__content__notifications">
                <div 
                  className={`Header__content__notifications icon ${newNotifications > 0 ? 'active' : ''}`} 
                  count={
                    newNotifications > 0 
                      ? newNotifications < 99 
                        ? newNotifications
                        : 99
                      : 0}
                  onClick={() => setShowNotifications(!showNotifications)}   
                />

                {showNotifications && 
                  <div ref={notifMenuRef}>
                    <Notifications 
                      notificationsList={notifications} 
                      seenNotif={seenNotif}
                      newNotifications={newNotifications}
                      submitSeenNotifications={submitSeenNotifications} 
                      setShowNotifications={setShowNotifications} 
                      setSeenNotif={setSeenNotif}
                      markAllAsRead={markAllAsRead}
                      />
                  </div>}
              </div>

              <div className="Header__content__user">
                <button
                  className="Header__content__user-circle"
                  onClick={() => setShowMenu(!showMenu)}
                >
                  {GET_USER_NAME() ? GET_USER_NAME().charAt(0) : '?'}
                </button>

                <ul
                  ref={userMenu}
                  className={
                    "Header__content__user-menu " + (showMenu ? "active" : "")
                  }
                >
                  {USER_MENU_ITEMS.map((item, i) => {

                  if (
                    // 1-3 lvl only
                    item.id === "profile" && GET_USER_LEVEL() >= 4 ||
                    item.id === "settings" && GET_USER_LEVEL() >= 4 ||
                    item.id === "salesdetalization" && GET_USER_LEVEL() >= 4 ||
                    
                    // 4 lvl only
                    item.id === "adminvatrates" && GET_USER_LEVEL() < 4 ||
                    item.id === "historicalvatrates" && GET_USER_LEVEL() < 4 ||
                    item.id === "adminsettings" && GET_USER_LEVEL() < 4 ||
                    item.id === "admincurrencyrates" && GET_USER_LEVEL() < 4
                    
                  ) { 
                    return;
                  }
  

                    return (
                      <Link
                        to={"/dashboard/" + item.id}
                        className={item.id}
                        exact="true"
                        key={i}
                        onClick={() => setShowMenu(false)}
                      >
                        {item.name}
                      </Link>
                    );
                  })}

                  <li>
                    {/*eslint-disable-next-line*/}
                    <a
                      className="logout"
                      href="#"
                      onClick={() => handleLogout()}
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
